import React, { useState, startTransition } from "react";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import { CardContainer, OuterCardContainer } from "../../components/Card/CardContainer";
import { Form, Col, Dropdown, Row, Spin, Tabs, Tag } from "antd";
import Text from "../../components/Text/Text";
import dayjs from "dayjs";
import color from "../../resource/color";
import { DownOutlined, EditOutlined, MinusCircleFilled } from "@ant-design/icons";
import {
  getProductQuotaById,
  getProductQuotaProduct,
  getQuotaTotalGroup,
  reportQuotaTransaction,
  reportQuotaUsed,
} from "../../datasource/ProductQuotaDatasource";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import { icon } from "../../resource";
import HistoryQuota from "./HistoryQuota";
import {
  NON_QUOTA_SHOP_PRICE_CONDITION,
  QUOTA_SHOP_PRICE_CONDITION,
  QUOTA_TYPE_DETAIL,
} from "../../definitions/QuotaType";
import Descriptions from "../../components/Description/Descriptions";
import { renderConditionQuotaText } from "../../definitions/renderConditionQuotaText";
import { numberFormatter } from "../../utility/Formatter";
import { MAP_STATUS_COLOR, MAP_STATUS_WORD } from "../../definitions/productQuota";
import { SlickCarousel } from "../../components/SlickCarousel/SlickCarousel";
import CardUsedQuota from "../../components/Card/CardUsedQuota";
import { RenderQuotaGroup, RenderQuotaIndividual, RenderQuotaTotal } from "./StepDup/StepTwoDup";
import StepThreeDup from "./StepDup/StepThreeDup";
import { zoneDatasource } from "../../datasource/ZoneDatasource";
import { useEffectOnce } from "react-use";
import { useNotificationContext } from "../../context/NotificationProvider";
import { formatFileSize } from "../../utility/formatFileSize";
import Permission from "../../components/Permission/Permission";

export const ProductQuotaDetailDup: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const quotaId = pathSplit[3];
  const isDetail = pathSplit[2] === "detail";
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  const [shopGroupData, setShopGroupData] = useState<any[]>([]);
  const [zoneList, setZoneList] = useState<any[]>([]);
  const [keyTotalBottom, setKeyTotalBottom] = useState("PRODUCT");
  const [loading, setLoading] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const { startUploadProcess } = useNotificationContext();
  const [loadingTab, setLoadingTab] = useState(false);
  const [loadingSection, setLoadingSection] = useState(false);
  const [pending, setPending] = useState(false);

  useEffectOnce(() => {
    fetchData();
    fetchShopGroupList();
    fetchZoneList();
  });

  const fetchData = async () => {
    setLoading(true);
    setLoadingSection(true);
    await getProductQuotaById(quotaId).then((res) => {
      const data = res.data;
      form1.setFieldsValue({
        ...data,
        startDate: data?.startDate,
        endDate: data?.endDate,
        startTime: data?.startDate,
        endTime: data?.endDate,
        limitQuantityOrder: data?.conditionQuota?.limitQuantityOrder,
        limitOrderDay: data?.conditionQuota?.limitOrderDay,
        limitOrderPerDayType: data?.conditionQuota?.limitOrderDayCondition?.allShop
          ? "allShop"
          : data?.conditionQuota?.limitOrderDayCondition?.perShop
            ? "perShop"
            : undefined,
        allShop: data?.conditionQuota?.limitOrderDayCondition?.allShop,
        perShop: data?.conditionQuota?.limitOrderDayCondition?.perShop,
        countOrder: data?.conditionQuota?.limitOrderDayCondition?.orderAmount,
      });
      form2.setFieldValue(
        "summary",
        data.quotaType === "QUOTA_TOTAL" ? [res.summary] : res.summary,
      );
      setTimeout(() => {
        setLoading(false);
      }, 300);
    });
    if (form1.getFieldValue("quotaType") !== "QUOTA_INDIVIDUAL") {
      await getQuotaTotalGroup(quotaId).then((res) => {
        const getValue = res?.productQuotaGroup;
        if (form1.getFieldValue("quotaType") === "QUOTA_GROUP") {
          const mapValueForm2 = getValue?.map((item: any, groupIndex: number) => {
            const mapProduct = item?.productQuota.map((pq: any) => {
              form2.setFieldValue(`limitQty-${pq?.product?.productId}`, pq?.orderLimit);
              form2.setFieldValue(`specialPrice-${pq?.product?.productId}`, pq?.discount);
              return {
                createdAt: pq?.createdAt,
                discount: pq?.discount,
                notDelete: pq?.notDelete,
                orderLimit: pq?.orderLimit,
                productQuotaGroupId: pq?.productQuotaGroupId,
                productQuotaId: pq?.productQuotaId,
                quotaId: pq?.quotaId,
                updatedAt: pq?.updatedAt,
                productId: pq?.productId,
                commonName: pq?.product?.commonName,
                marketPrice: pq?.product?.marketPrice,
                packSize: pq?.product?.packSize,
                productCodeNAV: pq?.product?.productCodeNAV,
                productGroup: pq?.product?.productGroup,
                productImage: pq?.product?.productImage,
                productName: pq?.product?.productName,
                saleUOM: pq?.product?.saleUOM,
                saleUOMTH: pq?.product?.saleUOMTH,
              };
            });
            item.shopTotalQuota.map((sq: any) => {
              form2.setFieldValue(
                `orderPerDay-${sq?.customerCompanyId}-${item?.groupNo}`,
                sq?.orderPerDay,
              );
              form2.setFieldValue(
                `quotaReceive-${sq?.customerCompanyId}-${item?.groupNo}`,
                sq?.quotaReceive,
              );
            });
            form2.setFieldsValue({
              quotaId: res?.quotaId,
              [`productQuotaGroupId-${item?.groupNo}`]: item?.productQuotaGroupId,
            });
            return {
              groupNo: item?.groupNo,
              productList: mapProduct,
              storeList: item?.shopTotalQuota.map((sq: any) => {
                return {
                  ...sq,
                  oldIsActive: sq?.isActive,
                  isChecked: false,
                };
              }),
            };
          });
          form2.setFieldsValue({ products: mapValueForm2 });
        } else if (form1.getFieldValue("quotaType") === "QUOTA_TOTAL") {
          getValue?.map((item: any, groupIndex: number) => {
            const mapProduct = item?.productQuota.map((pq: any) => {
              form2.setFieldValue(`limitQty-${pq?.product?.productId}`, pq?.orderLimit);
              form2.setFieldValue(`specialPrice-${pq?.product?.productId}`, pq?.discount);
              return {
                createdAt: pq?.createdAt,
                discount: pq?.discount,
                notDelete: pq?.notDelete,
                orderLimit: pq?.orderLimit,
                productQuotaGroupId: pq?.productQuotaGroupId,
                productQuotaId: pq?.productQuotaId,
                quotaId: pq?.quotaId,
                updatedAt: pq?.updatedAt,
                productId: pq?.productId,
                commonName: pq?.product?.commonName,
                marketPrice: pq?.product?.marketPrice,
                packSize: pq?.product?.packSize,
                productCodeNAV: pq?.product?.productCodeNAV,
                productGroup: pq?.product?.productGroup,
                productImage: pq?.product?.productImage,
                productName: pq?.product?.productName,
                saleUOM: pq?.product?.saleUOM,
                saleUOMTH: pq?.product?.saleUOMTH,
              };
            });
            item?.shopTotalQuota?.map((sq: any) => {
              form2.setFieldValue(`orderPerDay-${sq?.customerCompanyId}`, sq?.orderPerDay);
              form2.setFieldValue(`quotaReceive-${sq?.customerCompanyId}`, sq?.quotaReceive);
            });
            form2.setFieldsValue({
              products: mapProduct,
              stores: item?.shopTotalQuota?.map((sq: any) => {
                return {
                  ...sq,
                  productQuotaGroupId: item?.productQuotaGroupId,
                  quotaId: res?.quotaId,
                  oldIsActive: sq?.isActive,
                  isChecked: false,
                };
              }),
              quotaId: res?.quotaId,
              [`productQuotaGroupId-${groupIndex}`]: item?.productQuotaGroupId,
            });
          });
        }
      });
    } else if (form1.getFieldValue("quotaType") === "QUOTA_INDIVIDUAL") {
      await getProductQuotaProduct({
        quotaId,
        searchProduct: "",
      }).then((res) => {
        const mapValueForm2 = res?.data.map((item: any) => {
          form2.setFieldValue(`limitQty-${item.productId}`, item.orderLimit);
          form2.setFieldValue(`specialPrice-${item.productId}`, item.discount);
          const mapStore = item?.shopQuota?.map((sq: any) => {
            form2.setFieldValue(
              `orderPerDay-${item.productId}-${sq?.customerCompanyId}`,
              sq?.orderPerDay,
            );
            form2.setFieldValue(
              `quotaReceive-${item.productId}-${sq?.customerCompanyId}`,
              sq?.quotaReceive,
            );
            return {
              ...sq,
              oldIsActive: sq?.isActive,
              isChecked: false,
            };
          });
          form2.setFieldsValue({
            quotaId: item?.quotaId,
            [`productQuotaId-${item?.productId}`]: item?.productQuotaId,
          });
          return {
            ...item,
            storeList: mapStore,
          };
        });
        form2.setFieldsValue({
          products: mapValueForm2,
        });
      });
    }
    setLoadingSection(false);
  };
  const fetchShopGroupList = async () => {
    const res = await getShopGroup({
      company,
      take: 0,
      page: 0,
    });
    const shopGroup = res?.responseData?.data?.map((item: any) => ({
      label: item?.customerGroupName,
      value: item?.customerGroupName,
      key: item?.customerGroupId,
    }));
    const allOption = {
      label: "กลุ่มลูกค้าทั้งหมด",
      value: "ALL",
      key: undefined,
    };
    setShopGroupData([allOption, ...shopGroup]);
  };
  const fetchZoneList = async () => {
    await zoneDatasource.getAllZoneByCompany(company).then((res) => {
      const mapZone = res.map((item: any) => ({
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneName,
      }));
      const allOption = {
        label: "เขตทั้งหมด",
        value: "ALL",
        key: "ALL",
      };
      setZoneList([allOption, ...mapZone]);
    });
  };
  const downloadReportQuota = async ({ key }: { key: string }) => {
    const isTransaction = key === "TRANSACTION";
    const requestData = {
      company,
      quotaId: quotaId,
    };

    const getReport = isTransaction ? reportQuotaTransaction : reportQuotaUsed;

    try {
      const response = await getReport(requestData);
      if (!response) return;

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const downloadFile = async () => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        const fileName = `รายงาน${key === "TRANSACTION" ? "โควตารายคำสั่งซื้อ" : "สรุปยอดใช้โควตา"}_${form1?.getFieldValue("quotaName")}_${dayjs(form1?.getFieldValue("startDate")).format("DD-MM-YYYY")}-${dayjs(form1?.getFieldValue("endDate")).format("DD-MM-YYYY")}`;
        a.href = url;
        a.download = `${fileName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      };

      startUploadProcess(
        formatFileSize(blob.size),
        progressValue,
        setProgressValue,
        {
          placement: "bottomRight",
          duration: 2,
          label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
        },
        downloadFile,
      );
    } catch (error) {
      console.error(`Error generating ${isTransaction ? "transaction" : "used"} report:`, error);
    }
  };
  const PageTitle = () => {
    return (
      <PageTitleNested
        title={"รายละเอียดโควตา"}
        showBack
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการโควตาสินค้า", path: "/productQuota" },
              {
                text: "รายละเอียดโควตา",
                path: window.location.pathname,
              },
            ]}
          />
        }
        extra={
          <Row gutter={[16, 16]}>
            {loadingSection ? null : (
              <>
                <Col>
                  {["ACTIVE", "INACTIVE"].includes(form1?.getFieldValue("statusType")) && (
                    <Dropdown
                      menu={{
                        items: [
                          {
                            key: "USED",
                            label: (
                              <Text fontFamily='Sarabun' fontSize={14}>
                                รายงานสรุปยอดใช้โควตา
                              </Text>
                            ),
                          },
                          {
                            key: "TRANSACTION",
                            label: (
                              <Text fontFamily='Sarabun' fontSize={14}>
                                รายงานโควตารายคำสั่งซื้อ
                              </Text>
                            ),
                          },
                        ],
                        onClick: downloadReportQuota,
                      }}
                      trigger={["click"]}
                    >
                      <Button
                        iconPlacement='left'
                        typeButton='border-primary'
                        title='ดาวน์โหลดรายงาน'
                        iconRight={<DownOutlined />}
                        icon={
                          <img
                            src={icon.downloadFileIcon}
                            style={{ width: "20px", height: "19px" }}
                          />
                        }
                      />
                    </Dropdown>
                  )}
                </Col>
                <Permission permission={["productQuota", "edit"]}>
                  <Col>
                    {form1?.getFieldValue("statusType") !== "EXPIRED" && (
                      <Button
                        title={pending ? "กำลังโหลด..." : "แก้ไขโควตา"}
                        typeButton={pending ? "disabled" : "primary"}
                        icon={<EditOutlined />}
                        onClick={() => {
                          setPending(true);
                          startTransition(() => {
                            navigate("/productQuota/edit/" + quotaId, {
                              state: {
                                form1: form1.getFieldsValue(true),
                                form2: form2.getFieldsValue(true),
                              },
                            });
                            setPending(false);
                          });
                        }}
                        disabled={pending}
                      />
                    )}
                  </Col>
                </Permission>
              </>
            )}
          </Row>
        }
      />
    );
  };
  const renderQuotaDetails = () => {
    const datePattern = "DD/MM/YYYY, HH:mm น.";
    const dataQuotaDetail = [
      {
        label: "ชื่อโควตา",
        value: form1.getFieldValue("quotaName"),
      },
      {
        label: "ระยะเวลาโควตา",
        value: (
          <>
            {dayjs(form1.getFieldValue("startDate")).format(datePattern)} -{" "}
            {dayjs(form1.getFieldValue("endDate")).format(datePattern)}
            {form1.getFieldValue("daysPassed") ? (
              <>
                {form1.getFieldValue("daysPassed") >= 1 ? (
                  <>
                    <br />
                    (ผ่านมาแล้ว {form1.getFieldValue("daysPassed")} วัน)
                  </>
                ) : undefined}
              </>
            ) : null}
          </>
        ),
      },
      {
        label: "รูปแบบโควตา",
        value: (
          <Text fontFamily='Sarabun'>
            {QUOTA_TYPE_DETAIL[form1.getFieldValue("quotaType")]}{" "}
            {form1.getFieldValue("quotaType") === "QUOTA_TOTAL"
              ? `| จำนวน ${numberFormatter(form1.getFieldValue("quotaTotalAmount"), 2)} ${company !== "ICPL" ? "ตัน" : "ลัง"}`
              : null}
          </Text>
        ),
      },
      {
        label: "เงื่อนไขโควตา",
        value: (
          <>
            {renderConditionQuotaText(form1.getFieldValue("conditionQuota")).map((line, index) => (
              <Text fontFamily='Sarabun' key={index} style={{ display: "block" }}>
                {line}
              </Text>
            ))}
          </>
        ),
      },
      {
        label: "สถานะ",
        value:
          form1.getFieldValue("statusType") !== "EXPIRED" ? (
            <Tag color={MAP_STATUS_COLOR[form1.getFieldValue("statusType")]}>
              <Text fontFamily='Sarabun' color='white' fontWeight={600}>
                {MAP_STATUS_WORD[form1.getFieldValue("statusType")]}
              </Text>
            </Tag>
          ) : (
            <Text color='placeholder'>{MAP_STATUS_WORD[form1.getFieldValue("statusType")]}</Text>
          ),
        fullRow: true,
      },
      {
        label: "อัปเดตโดย",
        value: (
          <>
            {form1.getFieldValue("updatedBy")},{" "}
            {dayjs(form1.getFieldValue("updatedAt")).format(datePattern)}
          </>
        ),
        span: 10,
      },
    ];
    return (
      <>
        <Row gutter={24}>
          <Col span={12}>
            <Row>
              <Col span={24} style={{ marginBottom: 18 }}>
                <Text level={4} fontWeight={700}>
                  ข้อมูลโควตา
                </Text>
              </Col>
              {dataQuotaDetail.map(({ label, value, fullRow }, i) => (
                <React.Fragment key={`detail-${i}`}>
                  <Col span={24} style={{ padding: "4px 0" }}>
                    <Descriptions label={label} value={value || "-"} noPadding noColon />
                  </Col>
                  {fullRow && <Col span={24 - 14} />}
                </React.Fragment>
              ))}
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={24} style={{ marginBottom: 18 }}>
                <Text level={4} fontWeight={700}>
                  เงื่อนไขร้านค้า
                </Text>
              </Col>
              <Col span={24}>
                <Text fontSize={14} fontWeight={700}>
                  <img src={icon.ShopQuota} alt='' style={{ width: 18, height: 18 }} />
                  &nbsp;&nbsp;ร้านค้าที่เข้าร่วมโควตา
                </Text>
              </Col>
              <Col span={24} style={{ padding: "8px 0" }}>
                <Descriptions
                  label='ราคาพิเศษ'
                  value={
                    form1.getFieldValue("quotaShopPrice") === "NORMAL_PRICE"
                      ? "ราคาปกติ"
                      : "ราคาพิเศษ"
                  }
                  noPadding
                  noColon
                />
              </Col>
              <Col span={24} style={{ padding: "8px 0" }}>
                <Descriptions
                  label='การสั่งซื้อ'
                  value={QUOTA_SHOP_PRICE_CONDITION[form1.getFieldValue("quotaShopPriceCondition")]}
                  noPadding
                  noColon
                />
              </Col>

              <Col span={24} style={{ marginTop: 18 }}>
                <Text fontSize={14} fontWeight={700}>
                  <MinusCircleFilled style={{ color: color.Disable }} />
                  &nbsp;&nbsp;ร้านค้าที่ไม่ได้เข้าร่วมโควตา
                </Text>
              </Col>
              <Col span={24} style={{ padding: "8px 0" }}>
                <Descriptions
                  label='การสั่งซื้อ'
                  value={
                    NON_QUOTA_SHOP_PRICE_CONDITION[form1.getFieldValue("nonQuotaShopCondition")]
                  }
                  noPadding
                  noColon
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "28px 0px 28px 0px",
          }}
        >
          <img
            src={icon.productQuota_inactive}
            alt='quota icon'
            style={{ width: 22, height: 22, marginRight: 8 }}
          />
          <Text fontSize={16} fontWeight={700}>
            โควตา{form1.getFieldValue("quotaType") === "QUOTA_TOTAL" && "รวม"}
            ที่ถูกใช้
          </Text>
        </div>
        <SlickCarousel
          items={[form2.getFieldValue("summary")]}
          slidesToShow={1}
          slidesToScroll={1}
          renderItem={(group, slideIndex) => {
            return (
              <Row gutter={[16, 16]}>
                {(Array.isArray(group) ? group : []).map((item: any, idx) => {
                  return (
                    <Col key={idx} span={8}>
                      <CardUsedQuota
                        index={slideIndex * 15 + idx}
                        img={item?.productImage}
                        type={form1?.getFieldValue("quotaType")}
                        productName={item?.productName}
                        company={company}
                        usedCount={
                          form1?.getFieldValue("quotaType") === "QUOTA_INDIVIDUAL"
                            ? item?.sumQuotaUsed
                            : item?.quotaUsed
                        }
                        amount={
                          form1?.getFieldValue("quotaType") === "QUOTA_INDIVIDUAL"
                            ? item?.sumQuotaReceive
                            : item?.quotaReceive
                        }
                        status={form1.getFieldValue("statusType")}
                      />
                    </Col>
                  );
                })}
              </Row>
            );
          }}
        />
        <br />
      </>
    );
  };

  return (
    <OuterCardContainer>
      <CardContainer cutBottom>
        <>
          <PageTitle /> <br />
          <Tabs
            items={[
              {
                key: "DETAIL",
                label: (
                  <Text fontSize={14} fontWeight={400}>
                    รายละเอียด
                  </Text>
                ),
                children: (
                  <>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "80vh",
                        }}
                      >
                        <Spin size='large' />
                      </div>
                    ) : (
                      <>{renderQuotaDetails()}</>
                    )}
                    {loadingSection ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "80vh",
                        }}
                      >
                        <Spin size='large' />
                      </div>
                    ) : (
                      <>
                        {form1.getFieldValue("quotaType") === "QUOTA_GROUP" && (
                          <RenderQuotaGroup
                            form1={form1}
                            form2={form2}
                            shopGroupData={shopGroupData}
                            isDetail={isDetail}
                            zoneList={zoneList}
                          />
                        )}
                        {form1.getFieldValue("quotaType") === "QUOTA_INDIVIDUAL" && (
                          <RenderQuotaIndividual
                            form1={form1}
                            form2={form2}
                            shopGroupData={shopGroupData}
                            isDetail={isDetail}
                            zoneList={zoneList}
                          />
                        )}
                        {form1.getFieldValue("quotaType") === "QUOTA_TOTAL" && (
                          <>
                            <Row justify={"start"} gutter={8}>
                              <Col>
                                <Button
                                  typeButton={
                                    keyTotalBottom === "PRODUCT" ? "navy-blue" : "border-primary"
                                  }
                                  title='สินค้า'
                                  style={{
                                    width: "max-content",
                                  }}
                                  onClick={() => {
                                    setKeyTotalBottom("PRODUCT");
                                    setLoadingTab(true);
                                    setTimeout(() => {
                                      setLoadingTab(false);
                                    }, 300);
                                  }}
                                />
                              </Col>
                              <Col>
                                <Button
                                  typeButton={
                                    keyTotalBottom === "SHOP" ? "navy-blue" : "border-primary"
                                  }
                                  title='ร้านค้า'
                                  style={{
                                    width: "max-content",
                                  }}
                                  onClick={() => {
                                    setKeyTotalBottom("SHOP");
                                    setLoadingTab(true);
                                    setTimeout(() => {
                                      setLoadingTab(false);
                                    }, 300);
                                  }}
                                />
                              </Col>
                            </Row>
                            <br />
                            {loadingTab ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "40vh",
                                }}
                              >
                                <Spin size='large' />
                              </div>
                            ) : (
                              <>
                                {keyTotalBottom === "PRODUCT" ? (
                                  <RenderQuotaTotal
                                    form1={form1}
                                    form2={form2}
                                    isDetail={isDetail}
                                  />
                                ) : (
                                  <StepThreeDup
                                    form1={form1}
                                    form2={form2}
                                    isDetail={isDetail}
                                    zoneList={zoneList}
                                    shopGroupData={shopGroupData}
                                    loadingStep={loadingTab}
                                    setLoadingStep={setLoadingTab}
                                  />
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                ),
              },
              {
                key: "HISTORY",
                label: (
                  <Text fontSize={14} fontWeight={400}>
                    ประวัติทำรายการ
                  </Text>
                ),
                children: loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80vh",
                    }}
                  >
                    <Spin size='large' />
                  </div>
                ) : (
                  <HistoryQuota />
                ),
              },
            ]}
          />
        </>
      </CardContainer>
    </OuterCardContainer>
  );
};
